var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.79199 19.1666C4.44699 19.1666 4.16699 18.8866 4.16699 18.5416V4.79164C4.16699 4.44664 4.44699 4.16664 4.79199 4.16664C5.13699 4.16664 5.41699 4.44664 5.41699 4.79164V18.5416C5.41699 18.8866 5.13699 19.1666 4.79199 19.1666Z",
    fill: "#0061DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3753 9.58334H4.79199C4.44699 9.58334 4.16699 9.30334 4.16699 8.95834C4.16699 8.61334 4.44699 8.33334 4.79199 8.33334H19.3753C19.7203 8.33334 20.0003 8.61334 20.0003 8.95834C20.0003 9.30334 19.7203 9.58334 19.3753 9.58334Z",
    fill: "#0061DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3753 14.5834H4.79199C4.44699 14.5834 4.16699 14.3034 4.16699 13.9584C4.16699 13.6134 4.44699 13.3334 4.79199 13.3334H19.3753C19.7203 13.3334 20.0003 13.6134 20.0003 13.9584C20.0003 14.3034 19.7203 14.5834 19.3753 14.5834Z",
    fill: "#0061DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 19.1667H2.29167C1.0275 19.1667 0 18.1392 0 16.875V3.12501C0 1.86084 1.0275 0.833344 2.29167 0.833344H17.7083C18.9725 0.833344 20 1.86084 20 3.12501V16.875C20 18.1392 18.9725 19.1667 17.7083 19.1667ZM2.29167 2.08334C1.7175 2.08334 1.25 2.55084 1.25 3.12501V16.875C1.25 17.4492 1.7175 17.9167 2.29167 17.9167H17.7083C18.2825 17.9167 18.75 17.4492 18.75 16.875V3.12501C18.75 2.55084 18.2825 2.08334 17.7083 2.08334H2.29167Z",
    fill: "#0061DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375 5H0.625C0.28 5 0 4.72 0 4.375C0 4.03 0.28 3.75 0.625 3.75H19.375C19.72 3.75 20 4.03 20 4.375C20 4.72 19.72 5 19.375 5Z",
    fill: "#0061DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.6ea5bf130c31c144cc278997a2e8f8f4.svg";
export { ForwardRef as ReactComponent };